import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import BottomNavigationBar from './components/layout/BottomBar';
import LoginPage from './components/page/LoginPage';
import Index from './components/page/Index';
import Home from './components/page/Home';
import Table from './components/page/Table';
import TableChatPage from './components/page/TableChatPage';
import SettingsPage from './components/page/SettingsPage';
import Notifications from './components/page/Notifications';
import Profile from './components/page/Profile';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FeedbackPage from './components/page/FeedbackPage';
import FeedbacksPage from './components/page/FeedbacksPage';
import RestaurantPage from './components/page/RestaurantPage';
import TablesPage from './components/page/TablesPage';
import FlutterWebLoginPage from './components/page/FlutterWebLoginPage';
import NotificationSingle from './components/page/NotificationSingle';
import AnalyticsTracker from './components/AnalyticsTracker';
import TutorialPage from './components/page/TutorialPage';
import WelcomePage from './components/page/WelcomePage';
import MoreInfoPage from './components/page/MoreInfoPage';
import LegalConsentPage from './components/page/LegalConsentPage';
import PrivacyPreferencesPage from './components/page/PrivacyPreferencesPage';
import { AuthProvider } from './context/AuthContext';
import { initializePushNotifications } from './services/pushNotifications';
import LegalConsentGate from './components/auth/LegalConsentGate';
import ProfileCompletionGate from './components/auth/ProfileCompletionGate';

function PushNotificationBootstrap() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const userId = localStorage.getItem('user_id');
    if (!userId) return;
    initializePushNotifications(userId, navigate);
  }, [location.pathname, location.search, navigate]);

  return null;
}

function App() {

  return (
    <AuthProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Router basename={process.env.REACT_APP_BASE_PATH}>
          <AnalyticsTracker />
          <LegalConsentGate>
            <PushNotificationBootstrap />
            <ProfileCompletionGate>
            <Routes>
            <Route path="/" element={<> <Home /> </>} />
            {/* PRINCIPALS */}
            <Route path="/index" element={<> <Index /> <BottomNavigationBar valueToHighlight={0} /> </>} />

            {/* NOTIFICATIONS */}
            <Route path="/notifications" element={<> <Notifications /> <BottomNavigationBar valueToHighlight={1} /> </>} />
            <Route path="/notification" element={<> <NotificationSingle /> </>} />

            <Route path="/restaurants/:restaurant_id" element={<RestaurantPage />} />
            {/* TABLE */}
            <Route path="/table" element={<> <Table /> </>} />
            <Route path="/table/:group_id/chat" element={<TableChatPage />} />
            <Route path="/table/:group_id" element={<> <Table /> </>} />
            <Route path="/groups/:group_id" element={<> <Table /> </>} />

            {/* PROFILE */}
            <Route path="/user" element={<> <Profile /> <BottomNavigationBar valueToHighlight={3} /> </>} />
            <Route path="/user/:user_requested_id" element={<> <Profile /> <BottomNavigationBar valueToHighlight={3} /> </>} />

            {/* SETTINGS */}
            <Route path="/settings" element={<> <SettingsPage /> <BottomNavigationBar valueToHighlight={4} /> </>} />
            <Route path="/privacy-preferences" element={<PrivacyPreferencesPage />} />
            <Route path="/user/tables" element={<> <TablesPage /> <BottomNavigationBar valueToHighlight={3} /> </>} />
            <Route path="/user/:user_id/tables" element={<> <TablesPage /> <BottomNavigationBar valueToHighlight={3} /> </>} />

            {/* TUTORIAL */}
            <Route path="/tutorial" element={<TutorialPage />} />

            {/* FEEDBACKS */}
            <Route path="/feedback/:group_id" element={<FeedbackPage feedbackType="received" />} />
            <Route path="/feedbacks-received/:user_id" element={<FeedbacksPage feedbackType="received" />} />
            <Route path="/feedbacks-received" element={<FeedbacksPage feedbackType="received" />} />
            <Route path="/feedbacks-sent" element={<FeedbacksPage feedbackType="sent" />} />

            {/* LOGIN */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/flutter-web-login" element={<FlutterWebLoginPage />} />
            <Route path="/legal-consents" element={<LegalConsentPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/more-info" element={<MoreInfoPage />} />
            </Routes>
            </ProfileCompletionGate>
          </LegalConsentGate>
        </Router>
      </LocalizationProvider>
    </AuthProvider>
  );
}

export default App;
